<template>
  <div>
    <b-modal :active="isTranslationsModalVisible" :can-cancel="true" @close="closeTranslationsModal">
      <div class="has-background-white-ter p-4">
        <h3 class="is-size-5 has-text-weight-semibold mb-4">
          {{ descriptionForm.id ? "Редактировать перевод" : "Добавить перевод" }}
        </h3>
        <form @submit.prevent="saveDescription">
          <div class="columns is-multiline">
            <div class="column is-one-quarter">
              <b-field
                label="Язык"
                :type="descriptionErrors.lang_code ? 'is-danger' : ''"
                :message="descriptionErrors.lang_code && descriptionErrors.lang_code[0] || ''"
              >
                <b-select v-model="descriptionForm.lang_code" expanded>
                  <option v-for="lang in supportedLangs" :key="lang" :value="lang">{{ lang }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-three-quarters">
              <b-field
                label="Название"
                :type="descriptionErrors.name ? 'is-danger' : ''"
                :message="descriptionErrors.name && descriptionErrors.name[0] || ''"
              >
                <b-input v-model="descriptionForm.name" maxlength="255" />
              </b-field>
            </div>
            <div class="column is-full">
              <b-field
                label="Описание"
                :type="descriptionErrors.description ? 'is-danger' : ''"
                :message="descriptionErrors.description && descriptionErrors.description[0] || ''"
              >
                <b-input v-model="descriptionForm.description" type="textarea" />
              </b-field>
            </div>
            <div class="column is-full is-flex is-justify-content-end">
              <b-button class="mr-2" :disabled="isDescriptionSaving" @click="closeTranslationsModal">Отмена</b-button>
              <b-button type="is-info" native-type="submit" :loading="isDescriptionSaving">
                {{ descriptionForm.id ? "Сохранить" : "Добавить" }}
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </b-modal>

    <b-tabs v-model="activeTab" type="is-boxed">
      <b-tab-item label="Филиал">
        <div class="is-flex is-justify-content-space-between">
          <div class="has-background-white px-4 py-4 main-inner-set box-indent">
            <p class="is-uppercase heading-text-size has-text-grey has-text-weight-medium mb-3">Редактировать Филиала</p>
            <p class="mb-3">Введите данные</p>

            <b-field
              label="Компания"
              class="mt-3"
            >
              <div v-if="branch.company">
                <b-select
                  placeholder="Выберите филиал"
                  v-model="branch.company.id"
                >
                  <option
                    v-for="option of companies"
                    :value="option.id"
                    selected
                    :key="option.id"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </div>
            </b-field>
            <b-field label="Телеграм канал">
              <b-input
                type="text"
                v-model.trim="branch.telegram_chanel"
                placeholder="ID телеграм канала"
                required
              />
            </b-field>
            <label>
              <b>Название филиала</b>
            </label>
            <input
              class="input"
              type="text"
              placeholder="Название филиала"
              v-model="branch.name"
            >

            <div class="mt-5">
              <button
                class="button is-info"
                @click="save"
              >Сохранить
              </button>
              <button class="button is-warning mx-3">Деактивировать</button>
              <button
                class="button is-danger"
                @click="deleteBranch"
              >Удалить
              </button>
            </div>
          </div>

          <div class="has-background-white px-4 py-4 main-inner-set">
            <h4>СПИСОК ЗАВОДОВ</h4>
            <ul
              v-for="item of factories"
              :key="item.id"
              class="ml-5 list"
            >
              <li>
                <a @click="editFactory(item.id)">{{ item.name }}</a>
              </li>
            </ul>
            <router-link
              class="has-text-weight-medium"
              to="/factory-registration"
            >Зарегистрировать завод
            </router-link>
          </div>
        </div>
      </b-tab-item>

      <b-tab-item label="Переводы">
        <div class="has-background-white px-4 py-4">
          <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
            <h4 class="is-size-6 has-text-weight-medium">Переводы филиала</h4>
            <b-button type="is-info" @click="openCreateDescriptionModal">Добавить</b-button>
          </div>
          <b-table
            :data="descriptions"
            :loading="isTranslationsLoading"
            hoverable
            striped
            @cellclick="openEditDescriptionModal"
          >
            <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
              {{ props.row.id }}
            </b-table-column>
            <b-table-column field="lang_code" label="Язык" v-slot="props">
              {{ props.row.lang_code }}
            </b-table-column>
            <b-table-column field="name" label="Название" v-slot="props">
              {{ props.row.name || '-' }}
            </b-table-column>
            <b-table-column field="description" label="Описание" v-slot="props">
              {{ props.row.description || '-' }}
            </b-table-column>
            <b-table-column label="Удалить" centered v-slot="props">
              <b-button
                type="is-danger is-light"
                size="is-small"
                icon-right="trash"
                @click.stop="deleteDescription(props.row.id)"
              />
            </b-table-column>
          </b-table>
          <section v-if="descriptionsTotal > descriptionsPerPage" class="mt-4">
            <b-pagination
              :total="descriptionsTotal"
              :per-page="descriptionsPerPage"
              order="is-centered"
              icon-pack="fas"
              :current="descriptionsPage"
              class="base-table__pagination"
              @change="fetchDescriptions"
            />
          </section>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      branch_id: undefined,
      branch: [],
      companies: [],
      factories: [],
      activeTab: 0,
      isTranslationsModalVisible: false,
      isTranslationsLoading: false,
      isDescriptionSaving: false,
      descriptions: [],
      descriptionsTotal: 0,
      descriptionsPage: 1,
      descriptionsPerPage: 10,
      supportedLangs: ["ru", "kk", "en"],
      descriptionForm: {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      },
      descriptionErrors: {},
    };
  },
  watch: {
    activeTab(val) {
      if (val === 1) this.fetchDescriptions(this.descriptionsPage);
    },
  },
  created() {
    this.branch_id = this.$router.history.current.params.id.replace(/[^0-9]/g, "");
    this.getBranch();
    this.fetchCompanies();
    this.fetchBranchFactories();
  },
  mounted() {
  },
  methods: {
    async getBranch() {
      try {
        const { data } = await this.$axios.get(`admin/branches/${this.branch_id}`)
        this.branch = data?.data || {}
      } catch (e) {
        throw new Error(e)
      }
    },
    async deleteBranch() {
      try {
        await this.$axios.delete(`admin/branches/${this.branch_id}`)
        await this.$router.push("/filials-list");
      } catch (e) {
        throw new Error(e)
      }
    },
    async fetchCompanies() {
      try {
        const { data } = await this.$axios.get(`admin/companies`)
        this.companies = data?.data || []
      } catch (e) {
        throw new Error(e)
      }
    },
    async fetchBranchFactories() {
      try {
        const { data } = await this.$axios.get(`admin/branches/${this.branch_id}/factories`)
        this.factories = data?.data || []
      } catch (e) {
        throw new Error(e)
      }
    },
    async save() {
      try {
        const { data } = await this.$axios.put(`admin/branches/${this.branch_id}`, {
          name: this.branch.name,
          company_id: this.branch.company.id,
          telegram_chanel: this.branch.telegram_chanel
        })
        if (data?.code === 201) this.$router.push("/filials-list")
      } catch (e) {
        throw new Error(e)
      }
    },
    editFactory(factory_id) {
      this.$router.push(`/factory-editor/${factory_id}`);
    },
    openCreateDescriptionModal() {
      this.resetDescriptionForm();
      this.isTranslationsModalVisible = true;
    },
    openEditDescriptionModal(item) {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: item.id,
        lang_code: item.lang_code || "ru",
        name: item.name || "",
        description: item.description || "",
      };
      this.isTranslationsModalVisible = true;
    },
    closeTranslationsModal() {
      this.isTranslationsModalVisible = false;
      this.resetDescriptionForm();
    },
    resetDescriptionForm() {
      this.descriptionErrors = {};
      this.descriptionForm = {
        id: null,
        lang_code: "ru",
        name: "",
        description: "",
      };
    },
    async fetchDescriptions(page = 1) {
      this.descriptionsPage = page || 1;
      this.isTranslationsLoading = true;
      const offset = (this.descriptionsPage - 1) * this.descriptionsPerPage;
      try {
        const { data } = await this.$axios.get(
          `admin/branch-descriptions?branch_id=${this.branch_id}`
        );
        this.descriptions = data?.data || [];
        this.descriptionsTotal = data?.count || 0;
      } catch (e) {
        throw new Error(e);
      } finally {
        this.isTranslationsLoading = false;
      }
    },
    async saveDescription() {
      this.descriptionErrors = {};
      this.isDescriptionSaving = true;
      const payload = {
        branch_id: this.branch_id,
        lang_code: this.descriptionForm.lang_code,
        name: this.descriptionForm.name || null,
        description: this.descriptionForm.description || null,
      };
      try {
        if (this.descriptionForm.id) {
          await this.$axios.put(`admin/branch-descriptions/${this.descriptionForm.id}`, payload);
        } else {
          await this.$axios.post("admin/branch-descriptions", payload);
        }
        await this.fetchDescriptions(this.descriptionsPage);
        this.closeTranslationsModal();
      } catch (e) {
        this.descriptionErrors = e.error?.response?.data?.errors ?? {};
        throw e;
      } finally {
        this.isDescriptionSaving = false;
      }
    },
    async deleteDescription(id) {
      await this.$axios.delete(`admin/branch-descriptions/${id}`);
      await this.fetchDescriptions(this.descriptionsPage);
      if (this.descriptionForm.id === id) this.resetDescriptionForm();
    },
  },
};
</script>

<style>
.main-inner-set {
  flex: 1;
}

.list {
  list-style: disc;
}

.box-indent {
  margin-right: 40px;
}

</style>
